import {
  TRACKED_KEYWORD,
  TRACKED_KEYWORD_SENTIMENT,
} from '@modules/common/constants';
import { upperFirst } from 'lodash';
import { FieldName } from 'v2/core/entities/fields';

export const getDisplayNameFromField = (
  field: FieldName | string,
  labelName?: string,
): string => {
  switch (upperFirst(field)) {
    case 'EntitySentiment':
      return TRACKED_KEYWORD_SENTIMENT;
    case 'ReviewSentiment':
    case 'Sentiment':
      return 'User Sentiment';
    case 'Entity':
      return TRACKED_KEYWORD;
    default:
      return labelName ?? field;
  }
};
